import { useContext } from "react";
import { BoitelScenarioNewEditContext } from "../../contexts/boitelScenarioNewEditContext";

export default function useBoitelScnearioNewEditContext() {
  const value = useContext(BoitelScenarioNewEditContext);
  return value;
}
